import { StableRepository } from '@tcc-mono/vandijk/web/crm/data-access';
import { Stable } from '@tcc-mono/vandijk/shared/data-access/models';
import { Component, inject, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Params } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalController } from '@ionic/angular';
import { StackedListItem } from '@tcc-mono/shared/ui/stacked-list';

@UntilDestroy()
@Component({
  templateUrl: './stable-selector.component.html',
  styleUrls: ['./stable-selector.component.scss']
})
export class StableSelectorComponent implements OnInit {
  private readonly _repo: StableRepository = inject(StableRepository);
  private readonly _modalCtrl: ModalController = inject(ModalController);

  @Input() public stable: Stable;
  @Input() public params: Params = {};

  public readonly stables$: Observable<Stable[]> = this._repo.entities$;
  public readonly params$: Observable<Params> = this._repo.params$;
  public readonly loading$: Observable<boolean> = this._repo.loading$;

  public listItem: StackedListItem = {
    fields: [
      {
        property: 'name'
      },
      {
        property: (stable: Stable) => `UBN: ${this._getUbn(stable)}`,
      },
      {
        property: (stable: Stable) => `Bedrijf: ${stable.relation_name}`
      }
    ]
  }

  public ngOnInit(): void {
    this._repo.resetParams();
    this._repo.updateParams({
      ...this.params
    });

    this._repo.listenToParams()
      .pipe(untilDestroyed(this))
      .subscribe();
  }

  public setQ(val: string): void {
    this._repo.updateParams({ q: val });
  }

  public loadData(event: any): void {
    this._repo.scrollLoad(event);
  }

  public selectGroup(stable: Stable): void {
    this._modalCtrl.dismiss(stable);
  }

  private _getUbn = (stable: Stable): string => {
    const prop = stable.properties.find(p => p.code === 'UBN');
    return prop?.value || '';
  }
}
